import { TaxiLandmarkApiTaxiLandmarkUpdateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiLandmarkUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiLandmarkApiTaxiLandmarkUpdateRequest, config) =>
      appApiClient.taxiLandmarkApi.taxiLandmarkUpdate(req, config),
  });
